import { render } from "./ProfitShow.vue?vue&type=template&id=636e8189&scoped=true"
import script from "./ProfitShow.vue?vue&type=script&lang=js"
export * from "./ProfitShow.vue?vue&type=script&lang=js"

import "./ProfitShow.vue?vue&type=style&index=0&id=636e8189&scoped=true&lang=less"

import exportComponent from "D:\\过去云盘内容\\前端代码\\前端项目\\rdsv3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-636e8189"]])

export default __exports__